module.exports = __webpack_public_path__ + "media/images/pages/fig_culture_01-c3a0fe444b504bdee53e2211b306382b.png";